"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const SearchInput_1 = __importDefault(require("./SearchInput"));
exports.SearchInput = SearchInput_1.default;
//# sourceMappingURL=index.js.map